import React, { useCallback, useMemo, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import Loading from '../../../../components/molecules/Loading'
import { useListUserScheduledPrompts } from '../../../../api/denaliAssistant'
import FlexColumn from '../../../../components/molecules/FlexColumn'
import FlexRow from '../../../../components/molecules/FlexRow'
import OpalHeading from '../../../../components/opal/OpalHeading'
import SydLinkButton from '../../../../components/commonDesign/LinkButton'
import FadeIn from '../../../../components/molecules/Transitions/FadeIn'
import DeleteScheduleDialog from '../dialogs/DeleteSchedule'
import CopyScheduleInternalDialog from '../dialogs/CopyScheduleInternal'
import ScheduleListItem from './ScheduleListItem'

function UserScheduleList () {
  const { data: userPrompts, isLoading } = useListUserScheduledPrompts()
  const promptInfo = useMemo(() => {
    const prompts = userPrompts?.scheduledPrompts || []
    const filteredPrompts = prompts.filter(p => !p.isDigest)
    const digestPrompts = prompts.filter(p => p.isDigest)
    const eligibleForDigest = filteredPrompts.length > 1
    const hasDigest = digestPrompts.length > 0

    return {
      hasDigest,
      eligibleForDigest,
      allPrompts: prompts,
      standardPrompts: filteredPrompts,
      digestPrompts
    }
  }, [userPrompts])

  const history = useHistory()
  const deleteSchedule = useRef(null)
  const copySchedule = useRef(null)
  const handleEdit = useCallback((schedule) => {
    history.push(`/denali-ai/schedules/${schedule.scheduleId}/edit`)
  }, [history])
  const handleCopy = (schedule) => copySchedule.current?.open(schedule)
  const handleDelete = (schedule) => deleteSchedule.current?.open(schedule)

  if (isLoading) {
    return (
      <Loading />
    )
  }

  return (
    <FadeIn>
      <FlexColumn className='gap-xl'>
        {(promptInfo.eligibleForDigest && !promptInfo.hasDigest) ? (
          <FlexRow className='gap-xl justify-center items-center py-10'>
            <div>Summarize your scheduled prompts!</div>
            <SydLinkButton size='xl' variant='primary' to='/denali-ai/schedules/new-digest'>Create Digest</SydLinkButton>
          </FlexRow>
        ) : null}
        {(promptInfo.eligibleForDigest && promptInfo.hasDigest) ? (
          <FlexColumn className='gap-sm'>
            <OpalHeading className='font-serif font-size-sm'>Your Digests</OpalHeading>
            {(promptInfo.digestPrompts).map(prompt => (
              <ScheduleListItem
                key={prompt.scheduleId}
                scheduledPrompt={prompt}
                onEdit={handleEdit}
                onCopy={handleCopy}
                onDelete={handleDelete}
              />
            ))}
          </FlexColumn>
        ) : null}
        <FlexColumn className='gap-sm'>
          <OpalHeading className='font-serif font-size-sm'>Your Scheduled Prompts</OpalHeading>
          {(promptInfo.standardPrompts).map(prompt => (
            <ScheduleListItem
              key={prompt.scheduleId}
              scheduledPrompt={prompt}
              onEdit={handleEdit}
              onCopy={handleCopy}
              onDelete={handleDelete}
            />
          ))}
        </FlexColumn>
      </FlexColumn>
      <DeleteScheduleDialog ref={deleteSchedule} />
      <CopyScheduleInternalDialog ref={copySchedule} />
    </FadeIn>
  )
}

export default UserScheduleList
